import { Directive, HostBinding, Inject } from '@angular/core';
import { OPEN_EXTERNAL_LINK_IN_OWN_TAB } from '@rd/core/tokens/rd-lib.token';

@Directive({
  selector: '[rdOpenInNewTab]',
  standalone: false,
})
export class OpenInNewTabDirective {
  constructor(
    @Inject(OPEN_EXTERNAL_LINK_IN_OWN_TAB)
    protected openExternalLinkInOwnTab: boolean,
  ) {}

  @HostBinding('attr.target')
  public get attrTarget(): string {
    if (this.openExternalLinkInOwnTab) {
      return '_self';
    } else {
      return '_blank';
    }
  }

  @HostBinding('attr.rel')
  public get attrRel(): string {
    if (this.openExternalLinkInOwnTab) {
      return '';
    } else {
      return 'noopener noreferrer';
    }
  }
}
